import { default as camelCase } from 'lodash/camelCase';
import { default as upperFirst } from 'lodash/upperFirst';

export const toPascalCase = (str: string) => upperFirst(camelCase(str));

export { default as capitalize } from 'lodash/capitalize';
export { default as snakeCase } from 'lodash/snakeCase';
